import { takeLatest, put, call, select } from "redux-saga/effects";
import { actions } from "../util/actions";
import API from "../util/api";

function* updateUserILEARNProgress(action) {
  const { updateObj } = action;

  try {
    // Call the backend API to update user progress
    const response = yield call(API.updateILEARNUser, updateObj);

    if (response && response.status === "Success") {
      // Get the current state of chapters from the Redux store
      const chapters = yield select((state) => state.ilearn.chapters);

      if (typeof chapters !== "object" || chapters === null) {
        throw new TypeError("Expected chapters to be an object");
      }

      const { module_no, chapter_no } = updateObj;

      // Find and update the specific module and chapter in the chapters object
      const updatedChapters = {
        ...chapters, // Keep other modules unchanged
        [module_no]: {
          ...chapters[module_no],
          completedChapters: (chapters[module_no]?.completedChapters || 0) + 1,
          chapters: chapters[module_no]?.chapters?.map((chapter) => {
            if (chapter.chapter_no === chapter_no) {
              return {
                ...chapter,
                is_completed: 1,
                watch_date: new Date().toISOString(), // Add a watch date
              };
            }
            return chapter;
          }),
          is_completed:
            (chapters[module_no]?.completedChapters || 0) + 1 ===
            chapters[module_no]?.chapters?.length
              ? 1
              : 0,
        },
      };

      // Update the Redux store with the new chapters data
      yield put({
        type: actions.UPDATE_USER_ILEARN_PROGRESS,
        chapters: updatedChapters,
      });
    } else {
      console.error("Failed to update ILEARN progress in the backend.");
    }
  } catch (error) {
    console.error("Error updating ILEARN progress:", error);
  }
}


// Watcher Saga
export function* iLearnSaga() {
  yield takeLatest(
    actions.UPDATE_USER_ILEARN_PROGRESS_ASYNC,
    updateUserILEARNProgress
  );
}
